import {
	Box,
	BoxedRow,
	ButtonPrimary,
	Circle,
	Grid,
	IconCalendarRegular,
	IconInvoicePlanFileRegular,
	IconPercentRegular,
	ResponsiveLayout,
	Stack,
	Text3,
	skinVars,
	useScreenSize,
	Text,
	IconTimeRegular,
} from "@telefonica/mistica";
import React from "react";
import ImageDesktop from "../../assets/images/home-banner-desktop.png";
import ImageMobile from "../../assets/images/home-banner-mobile.png";
import { strings } from "../../localization";
import Banner from "../Banner";

interface IProps {
	onContinue(): void;
}

export const InformationAboutFGTS: React.FC<IProps> = (props) => {
	const { isDesktopOrBigger } = useScreenSize();
	const { title, subtitles, firstItem, secondItem, thirdItem, fourthItem, buttonPrimary } =
		strings.components.InformationAboutFGTS;
	const { onContinue } = props;

	return (
		<ResponsiveLayout className="font-family-vivotype">
			<Box paddingTop={isDesktopOrBigger ? 80 : 24}>
				<Banner
					desktopImg={ImageDesktop}
					mobileImg={ImageMobile}
					info={{
						heading: { children: title },
						infoBox: {
							maxWidth: { base: "279px", lg: "344px" },
						},
					}}
					height="440px"
					bgPosition={{ base: "right center", lg: "right top" }}
					applyDegrade
				/>
				<Box paddingY={isDesktopOrBigger ? 40 : 32}>
					<Stack space={8}>
						<Text weight="regular" size={isDesktopOrBigger ? 20 : 16} lineHeight={isDesktopOrBigger ? 28 : 24} color={skinVars.colors.textSecondary}>{subtitles.first}</Text>
						<Text weight="regular" size={isDesktopOrBigger ? 20 : 16} lineHeight={isDesktopOrBigger ? 28 : 24} color={skinVars.colors.textSecondary}>{subtitles.second}</Text>
					</Stack>
				</Box>
				<Box className="mini-card-grid">
					<Grid gap={isDesktopOrBigger ? 24 : 16} columns={isDesktopOrBigger ? 3 : 1}>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconInvoicePlanFileRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={firstItem}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconPercentRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={secondItem}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconCalendarRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={thirdItem}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconTimeRegular size={24} color={skinVars.colors.brand} />
								</Circle>
							}
							title={fourthItem}
						/>
					</Grid>
				</Box>
				<Box paddingTop={32} paddingBottom={isDesktopOrBigger ? 80 : 56}>
					<ButtonPrimary style={{ borderRadius: "999px" }} onPress={onContinue}>
						<Text3 medium color={skinVars.colors.textButtonPrimary}>
							{buttonPrimary}
						</Text3>
					</ButtonPrimary>
				</Box>
			</Box>
		</ResponsiveLayout>
	);
};
